class LoaderService {

  constructor($rootScope, $q) {
    var self = this;
    self.$rootScope = $rootScope;
  }

  start() {
    var self = this;
    self.$rootScope.$broadcast('loader', true);
  }

  stop() {
    var self = this;
    self.$rootScope.$broadcast('loader', false);
  }

}
LoaderService.$inject = ['$rootScope'];
export default LoaderService;
